"use strict";
/**
 * @streamlain/marketplace-locale-policy — sl-k94y Phase 4b R3
 *
 * Single source of truth for the visibility → enforcedLocale rule shared
 * by backend (`MarketplaceValidationService`, admin list/system-catalog
 * projection, seed metadata gates) and frontend (publish wizard, admin
 * editors). Previously lived as a backend-only util duplicated in
 * `publish-shared.tsx`; the duplicate let the policy drift between the
 * two ends and confused which locale is required for cross-deployment
 * vs. deployment-bound publish surfaces.
 *
 * Pure TypeScript, zero runtime dependencies — safe for browser bundles
 * and NestJS modules.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FALLBACK_LOCALE = void 0;
exports.resolveLocalePolicy = resolveLocalePolicy;
exports.resolveEnforcedLocale = resolveEnforcedLocale;
exports.publishRequiresSlotBaseline = publishRequiresSlotBaseline;
/**
 * Hard-coded baseline for cross-deployment surfaces. Decoupled from the
 * deployment's `defaultLocale` because cross-deployment audiences may
 * not speak it.
 */
exports.FALLBACK_LOCALE = 'en';
function resolveLocalePolicy(visibility) {
    switch (visibility) {
        case 'GLOBAL':
        case 'SYSTEM':
            return { crossDeployment: true };
        case 'WORKSPACE':
        case 'TENANT':
            return { crossDeployment: false };
        default: {
            const exhaustive = visibility;
            throw new Error(`marketplace-locale-policy: unhandled visibility "${exhaustive}"`);
        }
    }
}
/**
 * Resolve the enforced locale for a (visibility, deployment defaultLocale)
 * pair. Pure, sync — callers fetch `defaultLocale` from
 * `LocaleSettingsService` once and stamp every row.
 *
 * For cross-deployment visibilities the `defaultLocale` arg is ignored;
 * the baseline is always `FALLBACK_LOCALE`. The arg stays required so the
 * call sites that stamp deployment-bound rows can not forget to resolve
 * it.
 */
function resolveEnforcedLocale(visibility, defaultLocale) {
    return resolveLocalePolicy(visibility).crossDeployment
        ? exports.FALLBACK_LOCALE
        : defaultLocale;
}
/**
 * sl-k94y Phase 4b R3 (Cluster B): the visibility → enforcedLocale rule
 * applies uniformly to metadata maps (titlesI18n, descriptionsI18n,
 * detailDescriptionsI18n) AND slot-level maps (labelsI18n,
 * descriptionsI18n) on required slots. Previously slot validation
 * early-returned for !crossDeployment, which forked the policy from
 * metadata validation. The shared rule now treats every visibility as
 * "this baseline must be present"; consumers no longer branch.
 */
function publishRequiresSlotBaseline() {
    return true;
}
